import {CfgTaskConfigurationModel} from './cfg-task-configuration.model';
import {CfgTaskTypeAutoDestinationListModel} from './cfg-task-type-autodestination-list.model';

export class CfgTaskConfigurationListModel extends CfgTaskConfigurationModel {
  UserTaskType: string;
  TaskTypeCalculation: string;
  isSaved: boolean;
  isNew: boolean = false;
  TaskDestinations: CfgTaskTypeAutoDestinationListModel[] = [];
}
